import { ChatsIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Comment = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <ChatsIcon {...rest} size={Sizes[size]} color={fill} />;
};

Comment.displayName = 'Comment';
